import api from './api'

interface ITopicResponse {
  id: string,
  group: string,
}
export const getTopics = () => api.get<ITopicResponse[]>('/topic')
